import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ListFilters from 'components/sales/ListFilters/ListFilters';

const Feedback = ({
  meetingList = null,
  getFeedback= null,
  match,
  getSiteFilters = null,
  siteFilters = null
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  const Headers = [
    'Infra Id',
    'Business',
    'BA Name',
    'Avg Rating',
    'Mail Id',
    'Date',
    'Actions',
  ];

  useEffect(() => {
    if (getFeedback !== null)
      (async () => {
        setIsLoading(true);
        await getFeedback(match.params.id);
        setIsLoading(false);
      })();
  }, [getFeedback]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getSiteFilters();
      setIsLoading(false);
    })();
  }, [getSiteFilters]);

  useEffect(() => {
    const tableData = [
      'id',
      'infra_id',
      'client_name',
      'ba_name',
      'rating',
      'email',
      'created_at',
      
    ];
    if (meetingList && meetingList.resultSets) {
    const data = meetingList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action:
              
              [
                {
                  name: 'View Details',
                  link: `${baseUrl}/brand-activation/feedback-details`,
                },
              ]
          }
        )
      );
      console.log(data);
      if(data){
        setListData(data);
      }else{
        setListData([]);   
      }
    
   
    setPageCount(Math.ceil(meetingList.total / meetingList.per_page));
  }
  }, [meetingList]);

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getFeedback(filter, val.selected + 1);
    setIsLoading(false);
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    console.log(filterData);
    await getFeedback(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => {
    return (
      <Fragment>
        
        <Button
        onClick={filterToggle}
        className="filter-hamburger btn btn-transparent"
      >
        <img src={Images.Filter} alt="" />
        {localization.showFilters}
      </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.feedBack}
      Buttons={headerBtns}
    //   isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/sites-listing`}
    >
      {/* <TableSection
        data={listData}
        headers={Headers}
        detailList={meetingList}
        isId={false}
      /> */}
       <TableSection
        data={listData}
        isId={false}
        headers={Headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        srNo={meetingList?.from}
        // detailList={meetingList}
      />
       <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'1,2,3'}
        listFilterData={siteFilters ? siteFilters : null}
        feedBackFilter
      />
    </Layout>
  );
};

Feedback.propTypes = {
  meetingList: PropTypes.any,
  getFeedback: PropTypes.func,
  match: PropTypes.any,
};

export default Feedback;
